import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID, isDevMode } from '@angular/core';
import { RouterModule, NoPreloading } from '@angular/router';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SwRegistrationOptions } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { provideFirebaseApp, initializeApp }
  from '@angular/fire/app';
import { getAuth, provideAuth }
  from '@angular/fire/auth';
import { getFirestore, provideFirestore }
  from '@angular/fire/firestore';
import { getAnalytics, provideAnalytics }
  from '@angular/fire/analytics';
import { getStorage, provideStorage }
  from '@angular/fire/storage';
import { CookieConsentComponent } from './cookie-consent/cookie-consent.component';
import { SharedModule } from './shared/shared.module';

@NgModule({ declarations: [
        AppComponent,
        CookieConsentComponent,
    ],
    bootstrap: [AppComponent], imports: [SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        RouterModule.forRoot([
            {
                path: '',
                pathMatch: 'full',
                redirectTo: '/about'
            },
            {
                path: 'about',
                loadChildren: () => import('./about/about.module').then(m => m.AboutModule),
            },
            {
                path: 'blog',
                loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule),
            },
            {
                path: 'illustrations',
                loadChildren: () => import('./illustrations/illustrations.module').then(m => m.IllustrationsModule),
            },
            {
                path: 'book',
                loadChildren: () => import('./book/book.module').then(m => m.BookModule),
            },
            { path: '**', redirectTo: '/about' },
        ], {
            /* Quicklink preload raced with clicks; NoPreloading avoids that. */
            preloadingStrategy: NoPreloading,
            /* Manual scroll in ScrollService (nested scroll on app-root broke ViewportScroller/window) */
            scrollPositionRestoration: 'disabled',
            /* Match ScrollService; avoid RouterScroller anchor work outside zone racing the outlet */
            anchorScrolling: 'disabled',
        })], providers: [
        {
            provide: SwRegistrationOptions,
            useFactory: () => ({ enabled: !isDevMode() }),
        },
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideFirestore(() => getFirestore()),
        provideAuth(() => getAuth()),
        provideAnalytics(() => getAnalytics()),
        provideStorage(() => getStorage()),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
